import _ from 'lodash';
import { Component, OnInit, Input, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { updateVirtualEventPresent } from '../../features/data/data.actions';
import { SharedService } from '../../services/shared.service';
import { CAMPAIGN_TYPE } from '../../virtual-event.enums';
import { CampaignOptionModel } from '../../models/campaign-option.model';

@Component({
  selector: 'app-campaign-option-list',
  templateUrl: './campaign-option-list.component.html',
  styleUrls: ['./campaign-option-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CampaignOptionListComponent implements OnInit {
  @Input() virtualEventData: any = null;
  @Input() campaign: any = null;
  
  public options: any[] = [];
  public selected: any = null;

  public styles = {
    'height.px': 0
  };

  constructor(
    private store: Store,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    const selectedOption = _.get(this.virtualEventData, 'currentItem.currentOption', null);
    const options = _.get(this.campaign, 'campaignTypeData.presetOptions', []);
    this.options = _.map(options, option => {
      const model = new CampaignOptionModel(this.campaign, option);
      model.classList.push('campaign-option--playlist');
      if(option.id == selectedOption) {
        model.classList.push('campaign-option--is-live');
        model.isLive = true;

        this.selected = model;
      }
      return model;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const previousItem = _.get(changes, 'virtualEventData.previousValue.currentItem', null);
    const currentItem = _.get(changes, 'virtualEventData.currentValue.currentItem', null);

    const previousOptionId = _.get(previousItem, 'currentOption', null);
    const currentOptionId = _.get(currentItem, 'currentOption', null);

    const previousCampaignId = _.get(changes, 'campaign.previousValue.id', null);
    const currentCampaignId = _.get(changes, 'campaign.currentValue.id', null);

    if(_.isEqual(previousOptionId, currentOptionId)
      && _.isEqual(previousCampaignId, currentCampaignId)) {
        return;
    }

    const virtualEventData = _.get(changes, 'virtualEventData.currentValue', this.virtualEventData);
    const campaign = _.get(changes, 'campaign.currentValue', this.campaign);

    const selectedOption = _.get(virtualEventData, 'currentItem.currentOption', null);
    const options = _.get(campaign, 'campaignTypeData.presetOptions', []);
    this.options = _.map(options, option => {
      const model = new CampaignOptionModel(campaign, option);
      model.classList.push('campaign-option--playlist');
      if(option.id == selectedOption) {
        model.classList.push('campaign-option--is-live');
        model.isLive = true;

        this.selected = model;
      }
      return model;
    });
    this.styles["height.px"] = options.length * 82;
  }

  getImageUrl(option) {
    return option.imageUrl === '' ? '/images/blank-image.png': option.imageUrl;
  }

  isNotAuction(campaign) {
    return !_.isEqual(campaign.type, CAMPAIGN_TYPE.AUCTION);
  }

  onPresent(campaignId, option, clear = false) {
    if(this.selected) {
      this.selected.isLive = false;
    }
    
    this.selected = option;
    this.selected.isLive = true;

    this.store.dispatch({
      type: updateVirtualEventPresent.type,
      payload: {
        eventId: this.sharedService.id,
        campaignId, option: option.data, clear
      }
    });
  }

}
